/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 **/

import React from "react";
import T from "i18n-react/dist/i18n-react";

export default class MergeableMergeRow extends React.Component {
  getFieldClass(field, column) {
    let { disabled } = this.props;
    if (disabled) return "";
    return "selected";
  }

  render() {
    let { name, values } = this.props;

    return (
      <div className="row field-box">
        <div className="col-md-2">
          <label> {T.translate("merge_speakers." + name)} </label>
        </div>
        <div className="col-md-5">
          <div className={this.getFieldClass(name, 0) + " form-control field"}>
            {values[0]}
          </div>
        </div>
        <div className="col-md-5">
          <div className={this.getFieldClass(name, 1) + " form-control field"}>
            {values[1]}
          </div>
        </div>
      </div>
    );
  }
}
